import { Badge } from '@/components/ui/Badge';
import { DeviceState } from '@/models/device.models';

export function getDeviceState(state?: DeviceState): string {
  if (state?.installationFailed) {
    return 'Install Failed';
  }
  if (state?.installed) {
    return 'Installed';
  }
  if (state?.created) {
    return 'Created';
  }
  return '';
}

export function renderDeviceStateBadge(state?: DeviceState) {
  if (state?.installationFailed) {
    return (
      <Badge variant="destructive" className="h-6">
        Install Failed
      </Badge>
    );
  }
  if (state?.installed) {
    return (
      <Badge variant="green" className="h-6">
        Installed
      </Badge>
    );
  }
  if (state?.created) {
    return (
      <Badge variant="outline" className="h-6">
        Created
      </Badge>
    );
  }
}

export function renderDeviceStageBadge(state?: DeviceState) {
  if (state?.productionReady) {
    return (
      <Badge variant="green" className="h-6">
        Production
      </Badge>
    );
  } else {
    return (
      <Badge variant="blue" className="h-6">
        Staging
      </Badge>
    );
  }
}
